import PrivateRoute from '@Components/app-layout/PrivateRoute';
import AppRouter from '@Components/app-layout/Router';
import { useGlobalAuthStore } from '@Stores/global/auth';

import BlacklistLayout from './views/blacklist/Layout';
import DataExtractorLayout from './views/data-extractor/Layout';
import DatasourceLayout from './views/datasource/Layout';
import EmailTemplateLayout from './views/email-templates/Layout';
import IntegrationLayout from './views/integration/Layout';
import IpBlacklistLayout from './views/ip-blacklist/Layout';
import LogViewer from './views/log-viewer/Layout';
import TokenLayout from './views/token/Layout';
import UserLayout from './views/user/Layout';
import ValidatorLayout from './views/validator/Layout';

export default function SettingRoutes() {
  const { auth: { isManagerAdmin, isSuperAdmin } } = useGlobalAuthStore()
  return <AppRouter redirect='/settings/integrations'>
    <PrivateRoute path="/settings/integrations" component={IntegrationLayout} />
    <PrivateRoute path="/settings/blacklist" component={BlacklistLayout} />
    <PrivateRoute path="/settings/users" component={UserLayout} />
    <PrivateRoute path="/settings/ip-blacklist" component={IpBlacklistLayout} />
    <PrivateRoute path="/settings/email-templates" component={EmailTemplateLayout} />
    <PrivateRoute path="/settings/datasources" component={DatasourceLayout} />
    <PrivateRoute path="/settings/validators" component={ValidatorLayout} />
    <PrivateRoute path="/settings/data-extractors" component={DataExtractorLayout} />
    {(isManagerAdmin || isSuperAdmin) && <PrivateRoute path="/settings/tokens" component={TokenLayout} />}
    <PrivateRoute path='/settings/log-viewer' component={LogViewer} />
  </AppRouter>
}
